import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useB3Lang } from '@b3/lang';
import { formatDateSap } from '@/utils';

import { displayFormat } from '@/utils';

interface ListItem {
  orderId: string;
  firstName: string;
  lastName: string;
  poNumber?: string;
  status: string;
  totalIncTax: string;
  createdAt: string;

  ID?: string;
  DeliveryTypeCodeText: string;
  ShippingPeriod: {
    StartDateTime: string;
  };
  CreationDateTime: string
  ReleaseStatusCodeText: string;
  TypeCodeText: string;
}
export interface DeliveryItemCardProps {
  allTotal: number;
  filterData: any;
  index?: number;
  item: ListItem;
  isCompanyOrder: boolean;
}
const Flex = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  '&.between-flex': {
    justifyContent: 'space-between',
  },
}));

export function DeliveryItemCard({
  item,
  allTotal,
  filterData,
  index = 0,
  isCompanyOrder,
}: DeliveryItemCardProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const goToDetail = (item: ListItem) => {
    navigate(`/deliveryDetail/${item.ID}`, {
      state: {
        currentIndex: index || 0,
        searchParams: filterData,
        totalCount: allTotal,
        isCompanyOrder,
      },
    });
  };

  const b3Lang = useB3Lang();

  return (
    <Card key={item.orderId}>
      <CardContent
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
        }}
        onClick={() => goToDetail(item)}
      >
        <Flex className="between-flex">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: 'rgba(0, 0, 0, 0.87)',
              }}
            >
              {`# ${item.ID}`}
            </Typography>
            <Typography
              sx={{
                ml: 1,
              }}
              variant="body2"
            >
             {item.DeliveryTypeCodeText || '–'}
            </Typography>
          </Box>
          <Box>
          {`${item.ReleaseStatusCodeText}`}
          </Box>
        </Flex>
        <Typography
            sx={{
              color:'rgba(0, 0, 0, 0.87)',
              fontSize: '14px',
            }}
          >
            {`${b3Lang('deliveries.creationDate')}: ${formatDateSap(item.CreationDateTime)}`}
          </Typography>
          <Typography
            sx={{
              color:'rgba(0, 0, 0, 0.87)',
              fontSize: '14px',
            }}
          >
            {`${ b3Lang('deliveries.shippingDate')}: ${formatDateSap(item.ShippingPeriod.StartDateTime)}`}
          </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'normal',
              marginRight: theme.spacing(2),
            }}
          >
            {item.TypeCodeText}
          </Typography>
          <Typography>{`${displayFormat(item.createdAt)}`}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
